module.exports = __webpack_public_path__ + "img/bubble.c9f17cb0.png";